/** Shared positioning for overlays on #exploration-canvas-wrap (Tailwind classes must stay literal). */
export const explorationCanvasTopChromeClass =
  'absolute top-3.5 left-[18px] right-7.5 z-[30] flex items-center min-w-0';
export const explorationCanvasBottomRightClass = 'absolute right-[18px] bottom-[18px] z-[18]';

/** Measured breadcrumb width synced from ExplorationCanvasTopChrome. */
export const explorationCanvasBreadcrumbWidthVar = '--exploration-breadcrumb-width';

/** Fixed gap between breadcrumb and filter button (px). */
export const explorationBreadcrumbFilterGapPx = 12;

export const explorationCanvasWrapId = 'exploration-canvas-wrap';

/** Marks the filter button slot in ExplorationCanvasTopChrome (used for width measurement). */
export const explorationFilterSlotAttr = 'data-exploration-filter-slot';

export function findFilterSlotElement(element: HTMLElement): HTMLElement | null {
  return element.closest(`[${explorationFilterSlotAttr}]`);
}

export function syncExplorationBreadcrumbWidth(
  canvas: HTMLElement | null,
  breadcrumbWidthPx: number
): void {
  if (!canvas) return;
  canvas.style.setProperty(explorationCanvasBreadcrumbWidthVar, `${Math.ceil(breadcrumbWidthPx)}px`);
}

export function explorationFilterContainerMaxWidthStyle(): { maxWidth: string } {
  return {
    maxWidth: `calc(100% - var(${explorationCanvasBreadcrumbWidthVar}, 0px) - ${explorationBreadcrumbFilterGapPx}px)`,
  };
}

/** Max width available to the filter button within ExplorationCanvasTopChrome. */
export function readFilterSlotAvailableWidth(shell: HTMLElement): number {
  const slot = findFilterSlotElement(shell);
  if (!slot) {
    return shell.parentElement?.clientWidth ?? shell.clientWidth;
  }

  const { maxWidth } = getComputedStyle(slot);
  if (maxWidth && maxWidth !== 'none') {
    const parsed = Number.parseFloat(maxWidth);
    if (Number.isFinite(parsed) && parsed > 0) {
      return Math.floor(parsed);
    }
  }

  return slot.clientWidth;
}

export const explorationCanvasEmptyFiltersMessage = 'No data matching the current filters';

export const explorationCanvasEmptyVolumesMessage = 'No volumes matching the current filters';

export const explorationCanvasEmptyScopeMessage =
  'No volumes in this view match the current filters';

export function explorationCanvasEmptyStateHtml(
  message = explorationCanvasEmptyFiltersMessage
): string {
  return `<div class="empty-state" role="status">${message}</div>`;
}

export function applyExplorationCanvasEmptyState(
  container: HTMLElement,
  message = explorationCanvasEmptyFiltersMessage
): void {
  container.innerHTML = explorationCanvasEmptyStateHtml(message);
}

export function clearExplorationCanvasContent(container: HTMLElement): void {
  container.innerHTML = '';
}

export const explorationSidebarEmptyFiltersMessage =
  'No volumes match the current filters. Try adjusting or removing filters.';

export const explorationSidebarEmptyScopeMessage = explorationCanvasEmptyScopeMessage;
